var _path, _ellipse, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 40,
    viewBox: "0 0 27 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6083 1.77702C13.6939 1.72386 12.759 1.77525 11.8177 1.94122C5.29096 3.09206 0.932939 9.31596 2.08378 15.8427C3.23462 22.3694 9.45852 26.7274 15.9852 25.5766C19.6363 24.9328 22.6087 22.7015 24.3178 19.7178C18.8919 19.4023 14.1917 15.4051 13.2069 9.81968C12.6998 6.944 13.2622 4.12711 14.6083 1.77702Z",
    fill: "url(#paint0_linear)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.9226,
    cy: 39,
    rx: 13,
    ry: 1,
    fill: "#ECECEC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 10.4504,
    y1: 2.18231,
    x2: 14.618,
    y2: 25.8177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#676767",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C6C6C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNight);
export default __webpack_public_path__ + "static/media/night.b0027425900639d6faa5ae53ca5ca31a.svg";
export { ForwardRef as ReactComponent };